export class SortService {
  constructor () {
    'ngInject';
  }

  abcBy(name, secondName) {
    let fun = function by(a,b) {
      const compareValue = a[name].localeCompare(b[name]);

      if (compareValue === 0 && secondName) {
        return a[secondName].localeCompare(b[secondName]);
      }

      return compareValue;
    };
    return fun;
  }
}